<template>
  <div style="height: 100%; width: 100%">
    <l-map
      id="map-id"
      ref="mapRef"
      :zoom="zoom"
      :center="center"
      @move="$emit('move', $event)"
      @update:zoom="$emit('update:zoom', $event)"
      :options="{ attributionControl: false }"
      @ready="$emit('ready')"
    >
      <l-tile-layer
        :url="tileUrl"
        :attribution="attribution"
        subdomains="abcd"
        :max-zoom="20"
      ></l-tile-layer>

      <l-control-attribution
        position="bottomright"
        prefix="<a href='https://leafletjs.com/>'>Leaflet</a>"
      />

      <slot name="control" />
      <slot name="markers" />

      <div
        v-if="loading"
        class="loading-wrapper d-flex w-100 h-100 justify-center align-center"
        style=""
        @click.stop=""
      >
        <v-progress-circular
          color="black"
          indeterminate
          :size="80"
          :width="8"
        ></v-progress-circular>
      </div>
    </l-map>
  </div>
</template>
<script setup lang="ts">
import {
  LMap,
  LTileLayer,
  LControlAttribution,
} from "@vue-leaflet/vue-leaflet";
import "leaflet/dist/leaflet.css";
import { ref } from "vue";

defineEmits(["update:zoom", "move", "ready"]);

const mapRef = ref();
//https://leaflet-extras.github.io/leaflet-providers/preview/index.html
const attribution = ref(
  `&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>`
);
// CARTO now requires an API key for basemaps.cartocdn.com — see carto.com/basemaps/apikey.
// Falls back to the unauthenticated URL (shows their "API key required" watermark) until
// VITE_CARTO_API_KEY is set, so nothing breaks before the key exists.
const cartoApiKey = import.meta.env.VITE_CARTO_API_KEY;
const tileUrl = cartoApiKey
  ? `https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=${cartoApiKey}`
  : "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png";

defineExpose({
  mapRef,
});
defineProps<{
  center: number[];
  zoom: number;
  loading?: boolean;
}>();
</script>

<style scoped>
.leaflet-container {
  border-radius: 10px;
}

.loading-wrapper {
  position: relative;
  left: 0px;
  top: 0px;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 1000;
}
</style>
